module.exports = __webpack_public_path__ + "img/shareBack.31b2b303.png";